import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Length_Database, Msjs, Msjs_Validations, PatternsRegex } from 'src/app/shared/cons/common';
import { Icons } from 'src/app/shared/cons/icons';
import { UIService } from 'src/app/shared/services/ui.services';
import { CodigoRegistroBlService } from './services/codigo-registro-bl.service';
import { CodigoRegistro } from './models/codigo-registro';
import { Utils } from 'src/app/shared/helpers/utils';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { SnackBarType } from 'src/app/shared/types/snackbar-type';
import { SpinnerPageService } from '../../spinner-page/spinner-page.service';
import { FunctionsService } from 'src/app/shared/services/functions.service';
import { environment } from 'src/environments/environment';
import * as CryptoJS from 'crypto-js';


@Component({
  selector: 'app-gestionar-codigo-registro',
  templateUrl: './gestionar-codigo-registro.component.html',
  styleUrls: ['./gestionar-codigo-registro.component.scss']
})
export class GestionarCodigoRegistroComponent implements OnInit {
  readonly Icons: typeof Icons = Icons;
  readonly Msjs_Validations:typeof Msjs_Validations = Msjs_Validations;
  readonly PatternsRegex: typeof PatternsRegex = PatternsRegex;
  readonly Length_Database: typeof Length_Database = Length_Database;
  modalSb!: Subscription;
  private readonly key = environment.key.COMPROBANTE_ELECTRONICO_KEY;
  
  constructor(
        private uiService:UIService,
        private codigoRegistroBl: CodigoRegistroBlService,
        private authService: AuthService,
        private spinnerPageService: SpinnerPageService,
        private functionService:FunctionsService,
  ) { }

  ngOnInit(): void {
  }


  decryptCaptcha(response:string){
    const resp = JSON.parse(CryptoJS.AES.decrypt(response, this.key).toString(CryptoJS.enc.Utf8));
    return resp;  
  }
  

  onSubmit(f:NgForm){
    if(f.valid){
          this.modalSb= this.uiService.showModalQuestions({title:Msjs.TITULO_CONFIRMACION, message: Msjs.MENSAJE_CONFIRMACION, icon:Icons.QUESTION_MARK})
            .subscribe(async result=>{
              if(result){
                this.spinnerPageService.show();
                const codigo = new CodigoRegistro();
                codigo.codigo_registro =0;
                codigo.correo_electronico = f.value.correo_electronico;
                codigo.es_valido = true;
                await this.authService.getUserIDAsync().then(res=>{
                  codigo.usuario_creacion = res?.email!
                   //envia el correo con el codigo generado
                   this.functionService.SendMailGoDaddySMTPRegister(codigo.correo_electronico).then(resultado=>{
                    codigo.codigo_registro =  this.decryptCaptcha(resultado.data).code;
                    this.codigoRegistroBl.insertCodigo(codigo).then(res=>{
                      if(res.tx){
                        this.spinnerPageService.hide();
                        this.uiService.ShowSnackBar(SnackBarType.SUCCESS, Msjs.MSJ_GUARDADO_OK_CORREO, 3000);
                        f.reset();
                      }else{
                        this.spinnerPageService.hide();
                        this.uiService.ShowSnackBar(SnackBarType.ERROR, Msjs.MSJ_ERROR_DESCONOCIDO +':'+res.error, 3000);
                      }
                    });
                 
                  }); 
                
                });                
              }
            })
    }
  }

  cancelarCodigo(){}

}
